import React, { FC } from "react";

export interface EuropeaLogoProps {
  /** "light" for the dark hero on step 1, "dark" everywhere else. */
  variant?: "light" | "dark";
  className?: string;
}

/**
 * Europea Residences Group lockup.
 *
 * The real asset, the same file the public website's header serves from
 * /logo/europea-residences-group.svg. This used to be a hand-traced
 * reproduction of the monogram, drawn from the onboarding spec mockup because
 * no brand file had been supplied; the tenant platform was consequently the one
 * surface showing a logo nobody had approved. Serving the website's own file
 * means the two can no longer drift, and the traced paths are gone.
 *
 * The artwork is a fixed navy. The hero on step 1 is dark, so the light variant
 * knocks it out to white with a filter rather than keeping a second copy of the
 * file — brightness(0) flattens every path to black, invert(1) lifts it to
 * white, and neither depends on what colours the source uses.
 */
const EuropeaLogo: FC<EuropeaLogoProps> = ({
  variant = "dark",
  className = "",
}) => (
  <span
    className={`inline-flex items-center ${className}`}
    aria-label="Europea Residences Group"
    role="img"
  >
    <img
      src="/logo/europea-residences-group.svg"
      alt=""
      aria-hidden="true"
      className="h-full w-auto flex-none"
      style={
        variant === "light"
          ? { filter: "brightness(0) invert(1)" }
          : undefined
      }
    />
  </span>
);

export default EuropeaLogo;
